import React, { useEffect } from "react";

import useGlobal from "store";
import nowLogo from "assets/brand/logo.png";


const OnboardingNavbar = (props) => {

    const [onboardingState] = useGlobal(
        state => state.onboarding
    );

    useEffect(() => {
        console.log('onboarding state', onboardingState);
    }, [onboardingState]);

    const basicSteps = onboardingState.steps.basic.map(item => onboardingState.current_step === item.slug ? <li className="selected" key={item.slug}>{item.label}</li> : <li key={item.slug}>{item.label}</li>);
    const businessSteps = onboardingState.steps.business.map(item => onboardingState.current_step === item.slug ? <li className="selected" key={item.slug}>{item.label}</li> : <li key={item.slug}>{item.label}</li>);

    return (
        <>
            <div className="onboarding-sidebar">
                <img src={nowLogo} alt="now-logo" />
                <div className="wrapper">
                    <p>Basic Info</p>
                    <ul>
                        {basicSteps}
                    </ul>
                    <p>Business Details</p>
                    <ul>
                        {businessSteps}
                    </ul>
                </div>
            </div>
        </>
    );
}

export default OnboardingNavbar;